<template>
  <a-layout class='index animated fadeIn'>
    <div class="s_bf s_ptb0lr24">
      <a-tabs>
        <a-tab-pane key="1" tab="活动参与量">
          <actTotal></actTotal>
        </a-tab-pane>
        <a-tab-pane key="2" tab="参与地区统计" force-render>
          <a-form ref='form' :model='search' class="m-b-25" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
            <a-form-item>
              <a-radio-group button-style="solid" @change="onChangeRadio" v-model:value="search.day_type">
                <a-radio-button value="7">7天</a-radio-button>
                <a-radio-button value="30">30天</a-radio-button>
              </a-radio-group>
            </a-form-item>
            <a-form-item label="">
              <a-range-picker v-model:value="search.time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChange" :allowClear="false" />
            </a-form-item>
            <a-form-item>
              <a-button type="primary" htmlType='submit'>搜索</a-button>
            </a-form-item>
          </a-form>
          <a-button type="primary" @click='back' v-if="level!=0">返回上一级</a-button>
          <div class="m-b-25" ref="charts" style="width:100%;height:600px"></div>
          <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data'>
            
            <template v-slot:action="{ record }">
              <a @click='lookMore(record)' href="javascript:;" v-if="record.is_show_next">查看区域详情</a>
            </template>
          </a-table>
        </a-tab-pane>
      </a-tabs>
    </div>
  </a-layout>
</template>
<script>
import actTotal from "../components/act_total";
import { statisticsAttendArea } from "@/api/qrcodeActivitys";
import { onMounted, reactive, ref, toRefs } from "vue";
import { useChinaMap } from "@/hooks/useChinaMap.js";
import { useTime } from "@/hooks/utils/useTime";
export default {
  components: { actTotal },
  setup(props) {
    const state = reactive({
      activeKey: 1,
      data: [],
      level: 0,
    });
        const columns = [
      {
        title: "排行",
        dataIndex: "ranking",
        key: "ranking",
      },
      {
        title: "区域",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "活动参与量",
        dataIndex: "attend_num",
        key: "attend_num",
      },
      {
        title: "占比",
        dataIndex: "proportion",
        key: "proportion",
      },
    ];
    const { typeToStartEnd } = useTime();
    const search = ref({
      start_time: "",
      end_time: "",
      day_type: "7",
      city_id: "",
      province_id: "",
      type: 2,
      name: "",
      time: [],
    });
    // 页面筛选项搜索
    const pageSearchChange = async () => {
      initData(search.value);
    };
    // 7天/30天筛选
    const onChangeRadio = () => {
      var { start_time, end_time } = typeToStartEnd(search.value.day_type);
      search.value.start_time = start_time;
      search.value.end_time = end_time;
      search.value.time = [start_time, end_time];
    };
    //日期筛选
    const onChange = (e) => {
      search.value.start_time = e[0];
      search.value.end_time = e[1];
    };
    const mapStack = ref([{ id: "100000", name: "china" }]);
    // 地图 echartData
    const charts = ref(null);
    const { setMap, initMap } = useChinaMap();
    const handleMap = (data) => {
      setMap(mapStack.value[mapStack.value.length - 1], data);
    };
    const initData = async () => {
      let result = await statisticsAttendArea(search.value)
        .then((res) => res.data)
        .catch((error) => error);
      state.data = result.data;
            if (result.data[0].is_show_next==1) {
              if(columns[columns.length-1].title!='操作'){
                  columns.push({
                  title: "操作",
                  key: "action",
                  slots: { customRender: "action" },
                });
              }
          
      } else {
        columns.pop();
      }
       handleMap(state.data.map(v=>{v['total']=v.attend_num;return v}));
    };
    onMounted(() => {
      var { start_time, end_time } = typeToStartEnd("7");
      search.value.start_time = start_time;
      search.value.end_time = end_time;
      search.value.time = [start_time, end_time];
      initData(search.value);
      initMap(charts.value);
    });
    // 查看详情
    const lookMore = (e) => {
      state.level++;
      console.log(e)
      mapStack.value.push(e);
      if (state.level == 1) {
        search.value.province_id = e.id;
        search.value.city_id = "";
        initData(search.value);
      }
      if (state.level == 2) {
        search.value.province_id = "";
        search.value.city_id = e.id;
        initData(search.value);
      }
    };
    const back = () => {
      var map=mapStack.value.pop()
      if (state.level == 1) {
        state.level = 0;
        search.value.province_id = "";
        search.value.city_id = "";
        initData(search.value);
      }
      if (state.level == 2) {
        state.level = 1;
        search.value.province_id = mapStack.value[mapStack.value.length-1].id;
        search.value.city_id = "";
        initData(search.value);
      }
   
    };
    return {
      ...toRefs(state),
      columns,
      search,
      pageSearchChange,
      onChange,
      onChangeRadio,
      charts,
      lookMore,
      back,
    };
  },
};
</script>